<template>
    <div>
        <bar-chart :chart-data="chartData" :options="chartOptions" />
    </div>
</template>

<script>
import { Bar, mixins } from 'vue-chartjs';
import Chart from 'chart.js';
const { reactiveProp } = mixins;

export default {
    name: 'OrdersEvolutionChart',
    components: {
        barChart: {
            extends: Bar,
            mixins: [reactiveProp],
            props: ['options'],
            mounted() {
                this.renderChart(this.chartData, this.options);
            },
            watch: {
                chartData() {
                    this.renderChart(this.chartData, this.options);
                }
            }
        }
    },
    props: {
        chartData: Object,
        scaleLeft: Number,
        scaleRight: Number,
    },
    computed: {
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,

                legend: {
                    display: true,
                    position: 'top',
                    align: 'start',
                    labels: {
                        usePointStyle: false,
                        boxWidth: 20,
                        boxHeight: 12,
                        fontSize: 12,
                        generateLabels: function (chart) {
                            const original = Chart.defaults.global.legend.labels.generateLabels;
                            const labels = original(chart);
                            labels.forEach(label => {
                                label.lineWidth = undefined;
                                label.strokeStyle = undefined;
                                label.pointStyle = undefined;
                            });
                            return labels;
                        }
                    }
                },
                layout: {
                    padding: {
                        top: 10,
                        bottom: 40
                    }
                },


                scales: {
                    xAxes: [{
                        barThickness: 20,
                        maxBarThickness: 20,
                        categoryPercentage: 0.5,
                        barPercentage: 0.7
                    }],
                    yAxes: [
                        {
                            id: 'y-axis-0',
                            position: 'left',
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                max: this.scaleLeft,
                                stepSize: 1,
                                fontColor: '#4990e2'
                            }
                        },
                        {
                            id: 'y-axis-1',
                            position: 'right',
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                max: this.scaleRight,
                                //stepSize: 500,
                                fontColor: '#89c445'
                            },
                            gridLines: {
                                display: false
                            }
                        }
                    ]


                },
                tooltips: {
                    enabled: true,
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            const datasetLabel = data.datasets[tooltipItem.datasetIndex].label || '';
                            const value = tooltipItem.yLabel;
                            return `${datasetLabel}: ${value}`;
                        }
                    }
                },

                plugins: {
                    datalabels: {
                        display: false
                    }
                }

            };
        }
    }
};
</script>

<style scoped>
div {
    height: 420px;
}
</style>
